<template>
	<!-- 趣味报告 -->
	<div class="funreport">
		<div class="tagsNavatar">
			<ul v-bind:class="[ 'tags', funreport.key]">

				<li v-for="(item, $index) in tags" @click="countTags(item, this)" @animationend="removeAnimate('rubberBand')">
					<img v-bind:src="funreport.pic.replace('animal', item).replace('../', './')">
					<i class="tagCount">{{tagObj[item].num}}
						<i class="add" v-on:animationend.self="removeAnimate()">+1</i>
						<i class="minus" v-on:animationend.self="removeAnimate()">-1</i>
					</i>
				</li>
			</ul>
			<div class="animal">
				<!-- <router-link :to="'/download'"> -->
					<img v-bind:src="funreport.pic.replace('../', './')" >
				<!-- </router-link> -->
			</div>
		</div>
		<!-- <p class="saveTip">点击动物保存动物画像</p> -->
		<p class="short_description">{{funreport.short_description}}</p>
	</div>
	<!-- 趣味报告 -->
</template>

<script>
import { mapState } from 'vuex'
import router from '../router.js'
import APIS from '../apis.js'
import axios from 'axios'
import qs from 'qs';

export default {
	name: 'funBodyShare',
	data(){
		return {
			tags: (this.$store.state.sharereport != '') ? this.$store.state.sharereport.tags.split('、') : '',
			// funreport: {},
			// tagObj: {}
		}
	},
	mounted() {
		if(navigator.userAgent.indexOf('Android') > 0) {
			let allLi = document.querySelectorAll('.tagsNavatar .tags li');
			for(let i =0; i < allLi.length; i++) {
				allLi[i].className += 'android';
			}

			setInterval(function(){
				for(let i =0; i < allLi.length; i++) {
					allLi[i].style.marginTop = Math.random()*7+'px';
					allLi[i].style.marginBottom = Math.random()*7+'px';
				}
			}, 1000)
		};
	},
	computed: {
		tagObj(){
			var  result = {};
			if(this.$store.state.selfResult.tagstr=='') {
				let tags = this.$data.tags
				for(let i = 0; i < tags.length; i++) {
					result[tags[i]] = {};
					result[tags[i]].num = 0;
				}
			} else {
				let json = JSON.parse(this.$store.state.selfResult.tagstr.replace(/&quot;/g,'"').replace(/null/g,'0'));
				let tags = this.$data.tags
				for(let i = 0; i < tags.length; i++) {
					result[tags[i]] = {};
					result[tags[i]].num = json[tags[i]];
				}

			}
			return this.$data.tagObj = result;
		},
		...mapState({
			funreport: state => state.sharereport,
			selfResult: state => state.selfResult
		}),
	},
	methods: {
		countTags(whichTag, dom) {
			var _this = null,
					sendTags = {},
					componet = this;
			if(event.target.tagName.toLowerCase() =='img') {
				_this = event.target.parentNode
			} else if(event.target.tagName.toLowerCase() =='li') {
				_this = event.target;
			};

			if(navigator.userAgent.indexOf('Android') > 0) {
				_this.className += ' click';
				setTimeout(function() {
					_this.className = _this.className.replace('click', '');
				}, 1000);
			}

			if(_this.className.indexOf('clear') < 0) {
				let allLi = document.querySelectorAll('.tagsNavatar .tags li')
				for(let i =0; i < allLi.length; i++) {
					allLi[i].className += ' clear';
				}
			}

			if(!componet.$data.tagObj[whichTag].isLock) {
				componet.$data.tagObj[whichTag].num += 1;
				if(_this.className.indexOf('minus') > 0) {
					_this.className.replace('minus', '');
				}
				if(_this.className.indexOf('add') < 0) {
					_this.className += ' add';
				}
			} else {
				componet.$data.tagObj[whichTag].num -= 1;
				if(_this.className.indexOf('add') > 0) {
					_this.className.replace('add', '');
				}
				if(_this.className.indexOf('minus') < 0) {
					_this.className += ' minus';
				}
			}
			componet.$data.tagObj[whichTag].isLock = !componet.$data.tagObj[whichTag].isLock

			for(let i = 0; i < componet.$data.tags.length; i++) {
				let index = componet.$data.tags[i];
				sendTags[index] = componet.$data.tagObj[index].num;
			}
			var postData = {
				tagstr:JSON.stringify(sendTags),
				id: componet.selfResult.activate_id
			}
			axios.post(APIS.tagclick, qs.stringify(postData)).then(function(res) {
					if(res.data.code == 200) {
					}
			}).catch(function(error) {
				console.log(error);
			})

		},
		removeAnimate() {
			event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('add', '');
			event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('minus', '');
		},
	}
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}
@keyframes shakeOne {
	0% {
		transform: translate(0%,8%);
		-webkit-transform: translate(0%,8%);
	}
	50% {
		transform: translate(0%,-8%);
		-webkit-transform: translate(0%,-8%);
	}
	100% {
		transform: translate(0%,8%);
		-webkit-transform: translate(0%,8%);
	}
}

@keyframes shakeTwo {
	0% {
		transform: translate(0%,6%);
		-webkit-transform: translate(0%,6%);
	}
	50% {
		transform: translate(0%,-6%);
		-webkit-transform: translate(0%,-6%);
	}
	100% {
		transform: translate(0%,6%);
		-webkit-transform: translate(0%,6%);
	}
}

@keyframes shakeThree {
	0% {
		transform: translate( 0%, -10%);
		-webkit-transform: translate( 0%, -10%);
	}
	50% {
		transform: translate( 0%,10%);
		-webkit-transform: translate( 0%,10%);
	}
	100% {
		transform: translate(0%,-10%);
		-webkit-transform: translate(0%,-10%);
	}
}

@keyframes countZoom {
	0% {
		transform: scale(1);
		-webkit-transform: scale(1);
	}
	50% {
		transform: scale(2);
		-webkit-transform: scale(2);
	}
	100% {
		transform: scale(1);
		-webkit-transform: scale(1);
	}
}


@-webkit-keyframes shakeOne {
	0% {
		transform: translate(0%,8%);
		-webkit-transform: translate(0%,8%);
	}
	50% {
		transform: translate(0%,-8%);
		-webkit-transform: translate(0%,-8%);
	}
	100% {
		transform: translate(0%,8%);
		-webkit-transform: translate(0%,8%);
	}
}

@-webkit-keyframes shakeTwo {
	0% {
		transform: translate(0%,6%);
		-webkit-transform: translate(0%,6%);
	}
	50% {
		transform: translate(0%,-6%);
		-webkit-transform: translate(0%,-6%);
	}
	100% {
		transform: translate(0%,6%);
		-webkit-transform: translate(0%,6%);
	}
}

@-webkit-keyframes shakeThree {
	0% {
		transform: translate( 0%, -10%);
		-webkit-transform: translate( 0%, -10%);
	}
	50% {
		transform: translate( 0%,10%);
		-webkit-transform: translate( 0%,10%);
	}
	100% {
		transform: translate(0%,-10%);
		-webkit-transform: translate(0%,-10%);
	}
}

@-webkit-keyframes countZoom {
	0% {
		transform: scale(1);
		-webkit-transform: scale(1);
	}
	50% {
		transform: scale(2);
		-webkit-transform: scale(2);
	}
	100% {
		transform: scale(1);
		-webkit-transform: scale(1);
	}
}
	.funreport {
		position: relative;
		padding-top: 286px*0.5;
		width: 598px*0.5;
		margin: 30px auto 0 auto;
		.tagsNavatar {
			position: absolute;
			top: 0;
			width: 598px;
			height: 286px;
			background: url('../../static/images/funreport-tagbg.png') no-repeat 0 0;
			background-size: 598px;
			transform:  scale(0.5);
	    transform-origin: top left;
			.tags {
				li {
					position: absolute;
					z-index:1;
					font-size: 0;
					width: auto;
					&:nth-child(3n) {
						animation: shakeOne 5s infinite linear;
						transition: all 1s;
						-webkit-animation: shakeOne 5s infinite linear;
					}
					&:nth-child(3n+1) {
						animation: shakeTwo 3s infinite linear;
						transition: all 1s;
						-webkit-animation: shakeTwo 3s infinite linear;
					}
					&:nth-child(3n+2) {
						animation: shakeThree 4s infinite linear;
						transition: all 1s;
						-webkit-animation: shakeThree 4s infinite linear;
					}
					&.clear {
						z-index: 3;
						&:before{
							content: '';
							display: none;
						}
					}
					&.add {
						.tagCount .add {
							display: block;
							animation: countZoom 2s;
						}
					}
					&.minus {
						.tagCount .minus {
							display: block;
							animation: countZoom 2s;
						}
					}
					&.android {
						&.click {
							.tagCount {
								font-size: topx(36rem * 0.5);
							}
						}
						.tagCount {
							transition: all 1s;
							.add, .minus {
								display: none;
							}
						}
					}
					.tagCount {
						position: absolute;
						top: 0;
						right: 0;
						font-size: topx(28rem * 0.5);
						line-height: topx(28rem * 0.5);
						color: #252323;
						font-style: normal;
						transform: translate( 140%, 0%);
						.add , .minus {
							position: absolute;
							top: 0;
							right: 0;
							color: #edc96f;
							display: none;
							font-style: normal;
							transform: translate(100%);
						}
					}
				}
				&.C {
					li:nth-child(1) {
				    top: 60%;
				    left: 4%;
					}
					li:nth-child(2) {
				    right: 0;
				    top: 40%;
					}
					li:nth-child(3) {
				    right: 7%;
				    top: 10%;
					}
					li:nth-child(4) {
				    right: 8%;
				    top: 55%;
					}
					li:nth-child(5) {
				    left: 0%;
				    bottom: 0%;
					}
					li:nth-child(6) {
				    left: 12%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(7) {
				    left: 0%;
				    top: 38%;
					}
					li:nth-child(8) {
				    right: 0%;
				    bottom: 0%;
					}
				}
				&.Cm {
					li:nth-child(1) {
				    top: 8%;
				    right: 10%;
					}
					li:nth-child(2) {
				    left: 0;
				    top: 29%;
					}
					li:nth-child(3) {
				    right: 7%;
				    top: 65%;
					}
					li:nth-child(4) {
				    right: 0%;
				    top: 37%;
					}
					li:nth-child(5) {
				    left: 12%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(6) {
				    left: 5%;
				    top: 55%;
					}
					li:nth-child(7) {
				    bottom: 0%;
				    left: 13%;
					}
					li:nth-child(8) {
				    left: 0%;
				    bottom: 18%;
					}
					li:nth-child(9) {
				    right: 0%;
				    bottom: 0%;
					}
				}
				&.Cp {
					li:nth-child(1) {
				    bottom: 0%;
				    left: 0%;
					}
					li:nth-child(2) {
				    left: 0;
				    top: 23%;
					}
					li:nth-child(3) {
				    left: 11%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(4) {
				    left: 7%;
				    bottom: 25%;
					}
					li:nth-child(5) {
				    right: 5%;
				    top: 40%;
					}
					li:nth-child(6) {
				    right: 0%;
				    bottom: 0%;
					}
					li:nth-child(7) {
				    bottom: 20%;
				    right: 8%;
					}
					li:nth-child(8) {
				    right: 15%;
				    top: 24%;
					}
					li:nth-child(9) {
				    right: 18%;
				    top: 0%;
					}
				}
				&.Cs {
					li:nth-child(1) {
				    top: 8%;
				    right: 2%;
					}
					li:nth-child(2) {
				    left: 0;
				    bottom: 20%;
					}
					li:nth-child(3) {
				    left: 0%;
				    top: 33%;
					}
					li:nth-child(4) {
				    right: 5%;
				    bottom: 0%;
					}
					li:nth-child(5) {
				    right: 13%;
				    bottom: 25%;
					}
					li:nth-child(6) {
				    right: 2%;
				    bottom: 38%;
					}
					li:nth-child(7) {
				    top: 5%;
				    left: 8%;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(8) {
				    left: 18%;
				    bottom: 0%;
					}
				}
				&.M {
					li:nth-child(1) {
				    top: 8%;
				    right: 8%;
					}
					li:nth-child(2) {
				    left: 7%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    left: -3%;
				    top: 22%;
					}
					li:nth-child(4) {
				    right: 18%;
				    top: 35%;
					}
					li:nth-child(5) {
				    left: 5%;
				    top: 34%;
					}
					li:nth-child(6) {
				    left: 2%;
				    bottom: 18%;
					}
					li:nth-child(7) {
				    bottom: 7%;
				    right: 2%;
					}
					li:nth-child(8) {
				    left: 18%;
				    bottom: 0%;
					}
					li:nth-child(9) {
				    right: 3%;
				    top: 50%;
					}
				}
				&.Mc {
					li:nth-child(1) {
				    top: 0%;
				    left: 12%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(2) {
				    left: 35%;
				    top: 20%;
					}
					li:nth-child(3) {
				    left: 0%;
				    top: 18%;
					}
					li:nth-child(4) {
				    left: 7%;
				    bottom: 0%;
					}
					li:nth-child(5) {
				    right: 5%;
				    bottom: 3%;
					}
					li:nth-child(6) {
				    right: 2%;
				    top: 28%;
					}
					li:nth-child(7) {
				    bottom: 17%;
				    right: 27%;
					}
					li:nth-child(8) {
				    bottom: 30%;
				    right: 12%;
					}
					li:nth-child(9) {
				    left: 3%;
				    bottom: 20%;
					}
					li:nth-child(10) {
				    left: 13%;
				    top: 37%;
					}
				}
				&.Mp {
					li:nth-child(1) {
				    right: 25%;
				    bottom: 22%;
					}
					li:nth-child(2) {
				    left: 18%;
				    top: 8%;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    right: 9%;
				    top: 9%;
					}
					li:nth-child(4) {
				    right: 0%;
				    top: 30%;
					}
					li:nth-child(5) {
				    left: -2%;
				    top: 28%;
					}
					li:nth-child(6) {
				    left: 6%;
				    top: 48%;
					}
					li:nth-child(7) {
				    bottom: 8%;
				    right: 7%;
					}
					li:nth-child(8) {
				    bottom: 10%;
				    left: 2%;
					}
				}
				&.Ms {
					li:nth-child(1) {
				    left: -2%;
				    bottom: 22%;
					}
					li:nth-child(2) {
				    right: 5%;
				    bottom: 8%;
					}
					li:nth-child(3) {
				    right: 5%;
				    bottom: 29%;
					}
					li:nth-child(4) {
				    left: 4%;
				    top: 18%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(5) {
				    left: 39%;
				    top: 0%;
					}
					li:nth-child(6) {
				    right: 6%;
				    top: 8%;
					}
					li:nth-child(7) {
				    top: 37%;
				    right: 15%;
					}
					li:nth-child(8) {
				    top: 40%;
				    left: 14%;
					}
					li:nth-child(9) {
				    bottom: 5%;
				    left: 18%;
					}
				}
				&.P {
					li:nth-child(1) {
				    left: 0%;
				    top: 12%;
					}
					li:nth-child(2) {
				    left: -1%;
				    bottom: 22%;
					}
					li:nth-child(3) {
				    right: 12%;
				    bottom: 32%;
					}
					li:nth-child(4) {
				    right: 2%;
				    bottom: 0%;
					}
					li:nth-child(5) {
				    left: 50%;
				    top: 0%;
					}
					li:nth-child(6) {
				    right: 4%;
				    top: 30%;
					}
					li:nth-child(7) {
				    top: 30%;
				    left: 3%;
					}
					li:nth-child(8) {
				    top: -3%;
				    left: 17%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(9) {
				    bottom: 5%;
				    left: 22%;
					}
					li:nth-child(10) {
				    top: 15%;
				    right: 10%;
					}
				}
				&.Pc {
					li:nth-child(1) {
				    right: 10%;
				    top: 4%;
					}
					li:nth-child(2) {
				    left: 3%;
				    top: 15%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    left: 32%;
				    top: 7%;
					}
					li:nth-child(4) {
				    left: 12%;
				    bottom: 8%;
					}
					li:nth-child(5) {
				    right: 15%;
				    bottom: 27%;
					}
					li:nth-child(6) {
				    left: 6%;
				    bottom: 30%;
					}
					li:nth-child(7) {
				    bottom: 10%;
				    right: 3%;
					}
					li:nth-child(8) {
				    bottom: 10%;
				    right: 35%;
					}
				}
				&.Pm {
					li:nth-child(1) {
				    left: -2%;
				    top: 20%;
					}
					li:nth-child(2) {
				    left: 5%;
				    top: 40%;
					}
					li:nth-child(3) {
				    right: 0%;
				    bottom: 38%;
					}
					li:nth-child(4) {
				    left: -1%;
				    bottom: 12%;
					}
					li:nth-child(5) {
				    right: 10%;
				    top: 0%;
					}
					li:nth-child(6) {
				    left: 20%;
				    bottom: 0%;
					}
					li:nth-child(7) {
				    bottom: 13%;
				    right: 3%;
					}
					li:nth-child(8) {
				    top: -6%;
				    left: 3%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(9) {
				    top: 20%;
				    right: 4%;
					}
					li:nth-child(10) {
				    bottom: 0%;
				    right: 15%;
					}
				}
				&.Ps {
					li:nth-child(1) {
				    left: 0%;
				    top: 13%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(2) {
				    left: 2%;
				    bottom: 0%;
					}
					li:nth-child(3) {
				    right: 0%;
				    top: 28%;
					}
					li:nth-child(4) {
				    right: -1%;
				    bottom: 0%;
					}
					li:nth-child(5) {
				    left: 25%;
				    top: -5%;
					}
					li:nth-child(6) {
				    left: -2%;
				    top: 30%;
					}
					li:nth-child(7) {
				    top: 3%;
				    right: 13%;
					}
					li:nth-child(8) {
				    bottom: 26%;
				    left: 3%;
					}
					li:nth-child(9) {
				    bottom: 28%;
				    right: 6%;
					}
				}
				&.S {
					li:nth-child(1) {
				    right: 3%;
				    bottom: 10%;
					}
					li:nth-child(2) {
				    left: 4%;
				    top: 8%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    right: 3%;
				    top: 6%;
					}
					li:nth-child(4) {
				    left: 6%;
				    bottom: 3%;
					}
					li:nth-child(5) {
				    left: -2%;
				    top: 35%;
					}
					li:nth-child(6) {
				    right: 13%;
				    top: 48%;
					}
					li:nth-child(7) {
				    top: 28%;
				    right: 23%;
					}
					li:nth-child(8) {
				    bottom: 17%;
				    right: 20%;
					}
					li:nth-child(9) {
				    bottom: 32%;
				    left: 19%;
					}
				}
				&.Sc {
					li:nth-child(1) {
				    left: 15%;
				    top: 15%;
					}
					li:nth-child(2) {
				    right: 10%;
				    bottom: 28%;
					}
					li:nth-child(3) {
				    left: 10%;
				    bottom: 36%;
					}
					li:nth-child(4) {
				    left: -1%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(5) {
				    right: 23%;
				    top: 38%;
					}
					li:nth-child(6) {
				    right: 3%;
				    top: 0%;
					}
					li:nth-child(7) {
				    bottom: 0%;
				    left: 15%;
					}
					li:nth-child(8) {
				    bottom: 20%;
				    left: -2%;
					}
					li:nth-child(9) {
				    top: 15%;
				    right: 19%;
					}
					li:nth-child(10) {
				    bottom: 0%;
				    right: 0%;
					}
				}
				&.Sm {
					li:nth-child(1) {
				    left: 10%;
				    top: 8%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(2) {
				    left: 45%;
				    top: 2%;
					}
					li:nth-child(3) {
				    left: 0%;
				    top: 27%;
					}
					li:nth-child(4) {
				    right: 0%;
				    bottom: 30%;
					}
					li:nth-child(5) {
				    right: 3%;
				    bottom: 8%;
					}
					li:nth-child(6) {
				    bottom: 2%;
				    left: 10%;
					}
					li:nth-child(7) {
				    bottom: 22%;
				    left: 3%;
					}
					li:nth-child(8) {
				    top: 20%;
				    right: 2%;
					}
				}
				&.Sp {
					li:nth-child(1) {
				    left: 5%;
				    bottom: 38%;
					}
					li:nth-child(2) {
				    right: 13%;
				    bottom: 12%;
					}
					li:nth-child(3) {
				    right: 1%;
				    bottom: 3%;
					}
					li:nth-child(4) {
				    top: 0%;
				    right: 0%;
					}
					li:nth-child(5) {
				    left: 1%;
				    bottom: 5%;
					}
					li:nth-child(6) {
				    top: 21%;
				    right: 21%;
					}
					li:nth-child(7) {
				    bottom: 22%;
				    left: 20%;
					}
					li:nth-child(8) {
				    top: 28%;
				    left: -2%;
					}
					li:nth-child(9) {
				    top: 35%;
				    right: 8%;
					}
					li:nth-child(10) {
				    top: 0%;
				    left: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
				}
				&.cm {
					li:nth-child(1) {
				    right: 5%;
				    bottom: 10%;
					}
					li:nth-child(2) {
				    right: 5%;
				    bottom: 25%;
					}
					li:nth-child(3) {
				    right: 26%;
				    top: 0%;
					}
					li:nth-child(4) {
				    top: 33%;
				    right: 0%;
					}
					li:nth-child(5) {
				    left: 1%;
				    bottom: 22%;
					}
					li:nth-child(6) {
				    top: 21%;
				    right: 8%;
					}
					li:nth-child(7) {
				    bottom: 40%;
				    left: 10%;
					}
					li:nth-child(8) {
				    top: 4%;
				    left: -2%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(9) {
				    top: 22%;
				    left: 12%;
					}
					li:nth-child(10) {
				    bottom: 5%;
				    left: 10%;
					}
				}
				&.cp {
					li:nth-child(1) {
				    right: 3%;
				    top: 6%;
					}
					li:nth-child(2) {
				    left: -1%;
				    top: 35%;
					}
					li:nth-child(3) {
				    right: 3%;
				    bottom: 20%;
					}
					li:nth-child(4) {
				    bottom: 23%;
				    left: 13%;
					}
					li:nth-child(5) {
				    left: 14%;
				    top: 12%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(6) {
				    bottom: 2%;
				    left: 3%;
					}
					li:nth-child(7) {
				    bottom: 40%;
				    right: 14%;
					}
					li:nth-child(8) {
				    bottom: 4%;
				    right: 5%;
					}
				}
				&.cs {
					li:nth-child(1) {
				    left: 6%;
				    top: 42%;
					}
					li:nth-child(2) {
				    left: -2%;
				    bottom: 25%;
					}
					li:nth-child(3) {
				    right: 9%;
				    top: 40%;
					}
					li:nth-child(4) {
				    top: 2%;
				    right: 10%;
					}
					li:nth-child(5) {
				    right: 18%;
				    bottom: 14%;
					}
					li:nth-child(6) {
				    bottom: 28%;
				    right: 3%;
					}
					li:nth-child(7) {
				    bottom: 0%;
				    left: 14%;
					}
					li:nth-child(8) {
				    bottom: -2%;
				    right: 2%;
					}
					li:nth-child(9) {
		        top: 7%;
				    left: -2%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
				}
				&.mc {
					li:nth-child(1) {
				    right: 0%;
				    bottom: 6%;
					}
					li:nth-child(2) {
				    right: 18%;
				    top: 35%;
					}
					li:nth-child(3) {
				    left: -2%;
				    bottom: 2%;
					}
					li:nth-child(4) {
				    bottom: 22%;
				    right: 6%;
					}
					li:nth-child(5) {
				    left: 0%;
				    bottom: 23%;
					}
					li:nth-child(6) {
				    top: 25%;
				    left: 13%;
					}
					li:nth-child(7) {
				    top: 2%;
				    left: 2%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(8) {
				    top: 5%;
				    right: 9%;
					}
				}
				&.mp {
					li:nth-child(1) {
				    left: 10%;
				    top: 3%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(2) {
				    left: 3%;
				    top: 48%;
					}
					li:nth-child(3) {
				    right: 15%;
				    top: 7%;
					}
					li:nth-child(4) {
				    bottom: 27%;
				    right: 3%;
					}
					li:nth-child(5) {
				    right: 11%;
				    bottom: 4%;
					}
					li:nth-child(6) {
				    top: 25%;
				    left: 0%;
					}
					li:nth-child(7) {
				    top: 29%;
				    right: 0%;
					}
					li:nth-child(8) {
				    top: 0%;
				    right: 34%;
					}
					li:nth-child(9) {
				    bottom: 5%;
				    left: -1%;
					}
				}
				&.ms {
					li:nth-child(1) {
				    left: 13%;
				    top: 26%;
					}
					li:nth-child(2) {
				    left: 3%;
				    top: 1%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    right: 17%;
				    top: 0%;
					}
					li:nth-child(4) {
				    top: 30%;
				    right: 3%;
					}
					li:nth-child(5) {
				    left: 0%;
				    bottom: 35%;
					}
					li:nth-child(6) {
				    bottom: 7%;
				    left: 5%;
					}
					li:nth-child(7) {
				    bottom: 32%;
				    right: 10%;
					}
					li:nth-child(8) {
				    bottom: 0%;
				    right: 3%;
					}
				}
				&.pc {
					li:nth-child(1) {
				    left: 14%;
				    top: 20%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(2) {
				    right: 18%;
				    bottom: 6%;
					}
					li:nth-child(3) {
				    right: -2%;
				    bottom: 27%;
					}
					li:nth-child(4) {
				    bottom: 2%;
				    left: 0%;
					}
					li:nth-child(5) {
				    left: -2%;
				    bottom: 26%;
					}
					li:nth-child(6) {
				    top: 37%;
				    right: 13%;
					}
					li:nth-child(7) {
				    top: 8%;
				    right: 3%;
					}
				}
				&.pm {
					li:nth-child(1) {
				    left: 6%;
				    bottom: 2%;
					}
					li:nth-child(2) {
				    left: 33%;
				    top: 15%;
					}
					li:nth-child(3) {
				    left: 2%;
				    top: 35%;
					}
					li:nth-child(4) {
				    top: 0%;
				    left: 20%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(5) {
				    left: 14%;
				    bottom: 26%;
					}
					li:nth-child(6) {
				    bottom: 10%;
				    right: 5%;
					}
					li:nth-child(7) {
				    top: 18%;
				    right: 8%;
					}
					li:nth-child(8) {
				    top: 43%;
				    right: 13%;
					}
				}
				&.ps {
					li:nth-child(1) {
				    left: -2%;
				    top: 38%;
					}
					li:nth-child(2) {
				    right: 4%;
				    bottom: 12%;
					}
					li:nth-child(3) {
				    left: 12%;
				    top: 10%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(4) {
				    bottom: 2%;
				    left: 4%;
					}
					li:nth-child(5) {
				    left: 14%;
				    bottom: 26%;
					}
					li:nth-child(6) {
				    top: 35%;
				    right: 0%;
					}
					li:nth-child(7) {
				    top: 3%;
				    right: 8%;
					}
				}
				&.sc {
					li:nth-child(1) {
				    right: 4%;
				    bottom: 8%;
					}
					li:nth-child(2) {
				    left: 6%;
				    top: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    left: 4%;
				    bottom: 2%;
					}
					li:nth-child(4) {
				    top: 3%;
				    right: 30%;
					}
					li:nth-child(5) {
				    left: 0%;
				    top: 23%;
					}
					li:nth-child(6) {
				    top: 42%;
				    right: 2%;
					}
					li:nth-child(7) {
				    bottom: 28%;
				    left: 0%;
					}
					li:nth-child(8) {
				    bottom: 20%;
				    right: 8%;
					}
				}
				&.scpm {
					li:nth-child(1) {
				    top: 10%;
				    left: 27%;
					}
					li:nth-child(2) {
				    left: 4%;
				    bottom: 8%;
					}
					li:nth-child(3) {
				    right: 24%;
				    top: 8%;
					}
					li:nth-child(4) {
				    bottom: 30%;
				    left: 17%;
					}
					li:nth-child(5) {
				    right: 15%;
				    top: 31%;
					}
					li:nth-child(6) {
				    top: 53%;
				    right: 2%;
					}
					li:nth-child(7) {
				    top: 36%;
				    left: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(8) {
				    bottom: 10%;
				    right: 21%;
					}
				}
				&.sm {
					li:nth-child(1) {
				    top: 16%;
				    left: 0%;
					}
					li:nth-child(2) {
				    left: 24%;
				    top: 1%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(3) {
				    right: 16%;
				    bottom: 25%;
					}
					li:nth-child(4) {
				    bottom: 6%;
				    right: 1%;
					}
					li:nth-child(5) {
				    left: 8%;
				    top: 30%;
					}
					li:nth-child(6) {
				    bottom: 0%;
				    left: 4%;
					}
					li:nth-child(7) {
				    top: 39%;
				    right: 0%;
					}
					li:nth-child(8) {
				    bottom: 25%;
				    left: 10%;
					}
					li:nth-child(9) {
				    top: 5%;
				    right: 18%;
			    }
				}
				&.sp {
					li:nth-child(1) {
				    top: 3%;
				    right: 13%;
					}
					li:nth-child(2) {
				    left: 10%;
				    bottom: 25%;
					}
					li:nth-child(3) {
				    right: 20%;
				    bottom: 36%;
					}
					li:nth-child(4) {
				    top: 13%;
				    left: 14%;
					}
					li:nth-child(5) {
				    right: 0%;
				    top: 22%;
					}
					li:nth-child(6) {
				    top: 0%;
				    left: 0%;
						z-index: 3;
						&:before{
							content: '';
							position: absolute;
							z-index: 3;
							top: topx(-45rem);
							left: 50%;
							margin-left: topx(-75rem * 0.5) * .5;
							width: topx(75rem);
							height: topx(45rem);
							background: url('../../static/images/report-try.gif') no-repeat;
							background-size: topx(75rem) topx(45rem);
						}
					}
					li:nth-child(7) {
				    top: 31%;
				    left: -2%;
					}
					li:nth-child(8) {
				    bottom: 5%;
				    left: 2%;
					}
					li:nth-child(9) {
				    bottom: 5%;
				    right: 3%;
			    }
				}
			}
			.animal {
				position: absolute;
				z-index:2;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

			}
		}
		.saveTip {
			margin-top: topx(15rem * 0.5);
			text-align: center;
			color: #252323;
			font-size: topx(16rem * 0.5);
		}
		.short_description {
			margin: topx(40rem * 0.5) 0 topx(0rem * 0.5) 0;
			color: #252323;
			font-size: topx(22rem * 0.5);
			line-height: topx(40rem * 0.5);
		}
	}
</style>





// WEBPACK FOOTER //
// funBodyShare.vue?23f89222